<template>
  <div class="page-card-wrapper no-patient-card">
    <EditPatient ref="editPatient" @saveSuccess="saveSuccess" />
    <div class="page-card-title">
      {{
        $t('text.patient', {
          patient: $store.state.locale.patient
        }).toUpperCase()
      }}
    </div>
    <div class="page-card-content v-h-center">
      <el-empty
        :description="
          $t('text.there_are_no_patient_to_manage', {
            patients: $firstLetterCapitalize($store.state.locale.patients)
          })
        "
      >
        <el-button
          class="common-btn mt-10"
          @click="openDialog()"
          v-if="p('Patients.Add')"
          >{{
            $t('text.add_patient', {
              patient: $firstLetterCapitalize($store.state.locale.patient)
            })
          }}</el-button
        >
      </el-empty>
    </div>
  </div>
</template>

<script>
import EditPatient from '@/components/manage/patients/EditPatient.vue'
export default {
  components: {
    EditPatient
  },
  methods: {
    openDialog() {
      this.$refs.editPatient.openDialog()
    },
    saveSuccess() {
      this.$emit('saveSuccess')
    }
  }
}
</script>
